   <div class="modal-content contact-us-modal">

     <div class="modal-header">
       <h2 class="modal-title" id="myCenterModalLabel">Contact Us</h2>
       <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="close()" aria-label="Close"></button>
     </div>

     <div class="modal-body">
       <!-- Phone Numbers Section -->
       <div class="contact-section">
         <div class="contact-section-header">
           <i class="fe fe-phone contact-icon"></i>
           <h5 class="contact-section-title">Phone Numbers</h5>
         </div>
         <div class="contact-info-list">
           <div class="contact-info-item">
             <span class="contact-label">USA:</span>
             <a href="tel:+16232893254" class="contact-link">+1 623 289 3254</a>
           </div>
           <div class="contact-info-item">
             <span class="contact-label">India:</span>
             <a href="tel:+919403892050" class="contact-link">+91 94038 92050</a>
           </div>
           <div class="contact-info-item">
             <span class="contact-label">Ghana:</span>
             <a href="tel:+233277016940" class="contact-link">+233 27 701 6940</a>
           </div>
           <div class="contact-info-item">
             <span class="contact-label">Ireland:</span>
             <a href="tel:+353894620395" class="contact-link">+353 89 462 0395</a>
           </div>
         </div>
       </div>

       <!-- Physical Addresses Section -->
       <div class="contact-section">
         <div class="contact-section-header">
           <i class="fe fe-map-pin contact-icon"></i>
           <h5 class="contact-section-title">Physical Addresses</h5>
         </div>
         <div class="contact-info-list">
           <div class="contact-info-item">
             <span class="contact-label">USA:</span>
             <span class="contact-text">Suite 516, Rockville Innovation Centre, 155 Gibbs St, Rockville, MD, 20850</span>
           </div>
           <div class="contact-info-item">
             <span class="contact-label">India:</span>
             <span class="contact-text">1205, 12th Floor, 72 Corp, Saki Vihar Road, Sakinaka Junction, Mumbai - 400072</span>
           </div>
           <div class="contact-info-item">
             <span class="contact-label">Ghana:</span>
             <span class="contact-text">YOTA Building, La-Bawaleshie Road, East Legon, Accra, Ghana.</span>
           </div>
           <div class="contact-info-item">
             <span class="contact-label">Ireland:</span>
             <span class="contact-text">Suite 17, The Cubes Offices, Beacon South Quarter, Sandyford Business Park, Dublin 18, D18E932</span>
           </div>
         </div>
       </div>

       <!-- Email Section -->
       <div class="contact-section">
         <div class="contact-section-header">
           <i class="fe fe-mail contact-icon"></i>
           <h5 class="contact-section-title">Email Address</h5>
         </div>
         <div class="contact-info-list">
           <div class="contact-info-item">
             <a href="mailto:contact@globalpayex.com" class="contact-link email-link">contact@globalpayex.com</a>
           </div>
         </div>
       </div>
     </div>

     <div class="modal-footer">
       <button type="button" class="btn fis-btn btn-min-size" data-bs-dismiss="modal"
         (click)="close()">{{ 'LABELS.OK' | translate}}</button>
     </div>

   </div><!-- /.modal-content -->

